import { render } from "./promotionmodel.vue?vue&type=template&id=7b40aa79"
import script from "./promotionmodel.vue?vue&type=script&lang=js"
export * from "./promotionmodel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__